/**
 * THE ONE WAY A COUNT IS SAID WITH ITS NOUN: "1 hour", "2 hours", "1.5 hours", "3 leaves". On the const floor so every
 * layer reaches it -- a `const/` copy leaf cannot import `utils/` -- and so the singular-at-one decision is made once
 * rather than as an inline `=== 1 ? '' : 's'` at each sentence that counts something.
 *
 * `say` is how the sentence spells the count: `String` by default, a grouping formatter (`groupedCount`,
 * `formatNumber`) where the sentence groups digits, and `null` where the sentence does not say the count beside the
 * noun at all ("Missing required fields: a, b") -- the noun still agrees with it, so it still comes from here.
 * `QUAL-COUNT-NOUN-INLINE-TERNARY-001` convicts the inline ternary this replaces.
 */

/** @runtime-derived-ssot-helper (const-leaf-pinned): `count` and its noun, singular at exactly one, else the plural
 *  (`plural`, or the noun with an s); the count spelled by `say`, or left unsaid when `say` is null. */
export function countNoun(
	count: number,
	noun: string,
	plural: string = `${noun}s`,
	say: ((count: number) => string) | null = String,
): string {
	const word = count === 1 ? noun : plural;
	return say === null ? word : `${say(count)} ${word}`;
}

/** @runtime-derived-ssot-helper (const-leaf-pinned): the tail a sentence that names the first few of a list ends with,
 *  `, and N more` for a positive remainder and nothing otherwise -- the `rest > 0 ? \`, and ${rest} more\` : ''` the
 *  breach filing's sites sentence and the install-parity blocker each spelled (2026-09-28 fold). */
export function andMoreTail(rest: number): string {
	return rest > 0 ? `, and ${String(rest)} more` : '';
}
